import { appConfig } from '@config/app.config';
import { ManagerBase } from '@core/ManagerBase';
import type { IApiManager } from '@core/interfaces';

export interface ApiResponse<T = unknown> {
  success: boolean;
  message: string;
  data: T;
}

/** HTTP transport — Phase 5+ implementasyon */
export class ApiManager extends ManagerBase implements IApiManager {
  private baseUrl = appConfig.apiBaseUrl;

  get apiBaseUrl(): string {
    return this.baseUrl;
  }

  protected onInitialize(): void {
    // Phase 5
  }

  protected onShutdown(): void {
    // Phase 5
  }
}
